import React from 'react';
import { View } from 'react-native';

import Button from '../../../Components/Button';
import { textCategory } from '../../../Components/Reservation/constants';
import ResponsiveText from '../../../Components/ResponsiveText';
import themeStyle from '../../../Theme/styles';

type Props = {
  name: string;
  location_address: string;
  tags: string[];
  onGoBack: () => void;
  [key: string]: any;
};

const StoreAndTags = ({
  name,
  tags,
  location_address,
  onGoBack,
  ...rest
}: Props) => {
  return (
    <View {...rest}>
      <Button onPress={onGoBack} plain>
        <ResponsiveText
          category={textCategory.LARGE_HEADING}
          style={[themeStyle.spacingBottomSmall, themeStyle.bold]}
        >
          {name}
        </ResponsiveText>
      </Button>
      <ResponsiveText
        category={textCategory.TITLE}
        status="primary"
        style={themeStyle.bold}
      >
        {location_address} ·{' '}
        <ResponsiveText
          category={textCategory.TITLE}
          status="primary"
          style={[themeStyle.capitalize, themeStyle.bold]}
        >
          {tags.join(' · ')}
        </ResponsiveText>
      </ResponsiveText>
    </View>
  );
};

export default StoreAndTags;
